module.exports = __webpack_public_path__ + "static/media/ye.9802a254.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ye.svg
// module id = 291
// module chunks = 0